import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetAllEtiquetasDtoProps } from "api/Schemas/GetAllEtiquetasDto"

interface CategoryCardProps {
  category: GetAllEtiquetasDtoProps
  handleDeleteCategory: (id: string) => void
}
const CategoryCard = ({
  category,
  handleDeleteCategory,
}: CategoryCardProps) => {
  const handleDeleteClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    e.stopPropagation()
    handleDeleteCategory(id)
  }
  return (
    <div className='tw-bg-simple-10 tw-w-full tw-h-auto tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between tw-rounded hover:tw-shadow'>
      <div className='tw-flex tw-flex-row tw-items-center tw-cursor-pointer tw-w-full'>
        <span>{category?.icono === null ? "🏷️" : category?.icono}</span>
        <p className='tw-text-left tw-text-neutral tw-pl-4 tw-mb-0 tw-max-w-52 sm:tw-max-w-96 lg:tw-max-w-80 xl:tw-max-w-52 tw-truncate tw-flex-shrink'>
          {category?.nombre}
        </p>
      </div>
      <ButtonPrimeReact
        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
          // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig...
          handleDeleteClick(e, category.id)
        }
        className='!tw-z-10 !tw-text-danger !tw-bg-transparent !tw-min-w-0 !tw-border-none !tw-p-0'
      >
        <FontAwesomeIcon
          className='tw-w-6 tw-h-6'
          icon={["fal", "xmark"]}
        />
      </ButtonPrimeReact>
    </div>
  )
}

export default CategoryCard
